import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-all-delete-dialog',
  templateUrl: './all-delete-dialog.component.html',
  styleUrls: ['./all-delete-dialog.component.css']
})
export class AllDeleteDialogComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() checkboxLabel: string;
  @Input() checkboxState: boolean;
  constructor(private activeModal: NgbActiveModal,) { }

  ngOnInit() {
  }
  confirm() {
    this.activeModal.close('confirm');
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.close(null);
  }

}
